var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.32279V9.52279H6.13333V6.32279H9.33333V4.18945H6.13333C5.56754 4.18945 5.02492 4.41421 4.62484 4.81429C4.22476 5.21437 4 5.75699 4 6.32279Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8667 4.18945H14.6667V6.32279H17.8667V9.52279H20V6.32279C20 5.75699 19.7752 5.21437 19.3752 4.81429C18.9751 4.41421 18.4325 4.18945 17.8667 4.18945Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.8561H6.13333V18.0561H9.33333V20.1895H6.13333C5.56754 20.1895 5.02492 19.9647 4.62484 19.5646C4.22476 19.1645 4 18.6219 4 18.0561V14.8561Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8667 18.0561H14.6667V20.1895H17.8667C18.4325 20.1895 18.9751 19.9647 19.3752 19.5646C19.7752 19.1645 20 18.6219 20 18.0561V14.8561H17.8667V18.0561Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9333 11.1228H8.8V8.98945H10.9333V11.1228ZM10.9333 11.1228H13.0667V13.2561H10.9333V11.1228Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9333 13.2561V15.3895H8.8V13.2561H10.9333Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 13.2561H15.2V15.3895H13.0667V13.2561Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 11.1228V8.98945H15.2V11.1228H13.0667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.05f91f51.svg";
export { ForwardRef as ReactComponent };